import { inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { delay, filter, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppLoadingService {
  private readonly router = inject(Router);
  private readonly _isFirstNavigationComplete = signal(false);

  public readonly isFirstNavigationComplete =
    this._isFirstNavigationComplete.asReadonly();

  constructor() {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
        take(1),
        delay(1000), // avoid animation flickering
      )
      .subscribe(() => {
        if (document.startViewTransition) {
          document.startViewTransition(() => {
            this._isFirstNavigationComplete.set(true);
          });
        } else {
          this._isFirstNavigationComplete.set(true);
        }
      });
  }
}
